

(() => {
  'use strict';

  let toastEl = null;
  let toastTimer = null;

  const toast = (message) => {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'shd-toast';
      toastEl.setAttribute('role', 'status');
      toastEl.innerHTML = '<span class="shd-toast__mark" aria-hidden="true">&#10003;</span><span></span>';
      document.body.appendChild(toastEl);
    }
    toastEl.lastElementChild.textContent = message;
    toastEl.setAttribute('data-visible', 'true');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(() => toastEl.setAttribute('data-visible', 'false'), 2200);
  };

  const addToCart = async (button) => {
    const id = button.getAttribute('data-shd-add');
    if (!id || button.dataset.loading === 'true') return;

    const original = button.textContent;
    button.dataset.loading = 'true';
    if (button.classList.contains('shd-btn')) button.textContent = 'Wird hinzugefügt …';

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(id), quantity: 1 }] })
      });

      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'Das Produkt konnte nicht hinzugefügt werden.');
      }

      if (button.hasAttribute('data-shd-open-cart')) {

        await refreshCartDrawer();
        showOverlay('cart', button);
      } else {
        toast('Im Warenkorb');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      }
    } catch (error) {
      toast(error.message);
    } finally {
      button.dataset.loading = 'false';
      if (button.classList.contains('shd-btn')) button.textContent = original;
    }
  };

  const PILL_MAX = 99;
  const pillState = new WeakMap();

  const stateOf = (pill) => {
    if (!pillState.has(pill)) pillState.set(pill, { count: 1 });
    return pillState.get(pill);
  };

  const isOpen = (pill) => pill.getAttribute('data-open') === 'true';

  const paintPill = (pill) => {
    const state = stateOf(pill);
    const open = isOpen(pill);
    const count = pill.querySelector('[data-shd-cardqty-count]');
    const main = pill.querySelector('[data-shd-cardqty-toggle]');
    if (count) count.textContent = state.count;
    pill.querySelectorAll('[data-shd-cardqty-step]').forEach((button) => {
      button.tabIndex = open ? 0 : -1;
      const delta = Number(button.getAttribute('data-shd-cardqty-step'));
      button.disabled = delta < 0 ? state.count <= 1 : state.count >= PILL_MAX;
    });
    if (main) {
      main.setAttribute('aria-label', open
        ? state.count + ' in den Warenkorb legen'
        : 'In den Warenkorb');
    }
  };

  const closePill = (pill) => {
    pill.setAttribute('data-open', 'false');
    paintPill(pill);
  };

  const openPill = (pill) => {

    stateOf(pill).count = 1;
    pill.setAttribute('data-open', 'true');
    paintPill(pill);
  };

  const stepPill = (pill, delta) => {
    const state = stateOf(pill);
    state.count = Math.min(PILL_MAX, Math.max(1, state.count + delta));
    paintPill(pill);
  };

  const confirmPill = async (pill) => {
    if (pill.getAttribute('data-shd-busy') === 'true') return;
    const state = stateOf(pill);
    const variant = pill.getAttribute('data-shd-variant');
    pill.setAttribute('data-shd-busy', 'true');
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(variant), quantity: state.count }] })
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'Das Produkt konnte nicht hinzugefügt werden.');
      }
      toast(state.count > 1 ? state.count + '\u00D7 im Warenkorb' : 'Im Warenkorb');
      closePill(pill);
      document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    } catch (error) {
      toast(error.message);
    } finally {
      pill.removeAttribute('data-shd-busy');
    }
  };

  document.addEventListener('click', (event) => {
    document.querySelectorAll('[data-shd-cardqty][data-open="true"]').forEach((pill) => {
      if (!pill.contains(event.target)) closePill(pill);
    });
  });

  document.addEventListener('keydown', (event) => {
    if (event.key !== 'Escape') return;
    document.querySelectorAll('[data-shd-cardqty][data-open="true"]').forEach(closePill);
  });

  const WISH_KEY = 'shd:wishlist';

  const idOf = (entry) => (typeof entry === 'string' ? entry : entry && entry.id);

  const esc = (value) => String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

  const readWishlist = () => {
    try {
      const raw = JSON.parse(localStorage.getItem(WISH_KEY) || '[]');
      return raw.map((x) => (typeof x === 'string' ? { id: x, url: '', title: '', price: '', img: '' } : x));
    } catch (error) {
      return [];
    }
  };

  const writeWishlist = (list) => {
    try {
      localStorage.setItem(WISH_KEY, JSON.stringify(list));
    } catch (error) {
    }
  };

  const paintWishlist = () => {
    const ids = readWishlist().map(idOf);
    document.querySelectorAll('[data-shd-wish]').forEach((button) => {
      button.setAttribute('aria-pressed', String(ids.includes(button.getAttribute('data-shd-wish'))));
    });
  };

  const toggleWish = (button) => {
    const id = button.getAttribute('data-shd-wish');
    const list = readWishlist();
    const index = list.findIndex((x) => idOf(x) === id);
    if (index === -1) {
      list.push({
        id,
        url: button.getAttribute('data-shd-wish-url') || '',
        title: button.getAttribute('data-shd-wish-title') || '',
        price: button.getAttribute('data-shd-wish-price') || '',
        img: button.getAttribute('data-shd-wish-img') || '',
        kind: button.getAttribute('data-shd-wish-kind') || '',
        variant: button.getAttribute('data-shd-wish-variant') || ''
      });
      button.setAttribute('data-shd-pop', 'true');
      setTimeout(() => button.removeAttribute('data-shd-pop'), 380);
      toast('Gemerkt');
    } else {
      list.splice(index, 1);
      toast('Nicht mehr gemerkt');
    }
    writeWishlist(list);
    paintWishlist();
    paintWishDot();
    renderWishlist();
  };

  const renderWishlist = () => {
    const box = document.querySelector('[data-shd-wish-list]');
    const empty = document.querySelector('[data-shd-wish-empty]');
    const count = document.querySelector('[data-shd-wish-count]');
    if (!box) return;
    const list = readWishlist();
    if (count) count.textContent = list.length;
    if (empty) empty.hidden = list.length > 0;

    box.innerHTML = list.map((p) => {
      const url = esc(p.url || '#');
      const title = esc(p.title);
      const action = p.variant
        ? `<button type="button" class="shd-btn shd-btn--sm shd-btn--block" data-shd-add="${esc(p.variant)}">In den Warenkorb</button>`
        : `<a href="${url}" class="shd-btn shd-btn--sm shd-btn--block">Zum Produkt</a>`;

      return `
      <article class="shd-wishcard">
        <a href="${url}" class="shd-wishcard__fig" aria-label="${title}">
          ${p.img ? `<img src="${esc(p.img)}" alt="" width="96" height="126" loading="lazy">` : ''}
        </a>
        <div class="shd-wishcard__body">
          <a href="${url}" class="shd-wishcard__title">${title}</a>
          ${p.kind ? `<p class="shd-wishcard__kind">${esc(p.kind)}</p>` : ''}
          <p class="shd-wishcard__price">${esc(p.price)}</p>
          ${action}
        </div>
        <button type="button" class="shd-wish shd-wishcard__drop shd-iconbtn shd-iconbtn--plain"
                data-shd-wish="${esc(p.id)}" aria-pressed="true"
                aria-label="${title} aus der Merkliste entfernen">
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 20s-7.4-4.6-7.4-9.3A4.1 4.1 0 0 1 12 8.2a4.1 4.1 0 0 1 7.4 2.5C19.4 15.4 12 20 12 20Z"/></svg>
        </button>
      </article>`;
    }).join('');
  };

  document.addEventListener('click', (event) => {
    const step = event.target.closest('[data-shd-cardqty-step]');
    if (step) {
      event.preventDefault();
      const pill = step.closest('[data-shd-cardqty]');
      if (pill && isOpen(pill) && !step.disabled) {
        stepPill(pill, Number(step.getAttribute('data-shd-cardqty-step')));
      }
      return;
    }
    const toggle = event.target.closest('[data-shd-cardqty-toggle]');
    if (toggle) {
      event.preventDefault();
      const pill = toggle.closest('[data-shd-cardqty]');
      if (pill) {
        if (isOpen(pill)) {
          confirmPill(pill);
        } else {
          openPill(pill);
        }
      }
      return;
    }
    const add = event.target.closest('[data-shd-add]');
    if (add) {
      event.preventDefault();
      addToCart(add);
      return;
    }
    const wish = event.target.closest('[data-shd-wish]');
    if (wish) {
      event.preventDefault();
      toggleWish(wish);
      return;
    }
    const qty = event.target.closest('[data-shd-qty]');
    if (qty) {
      event.preventDefault();
      if (qty.disabled) return;
      changeLine(qty.getAttribute('data-shd-line'), qty.getAttribute('data-shd-qty'));
    }
  });

  const paintWishDot = () => {
    const dot = document.querySelector('[data-shd-wish-dot]');
    if (dot) dot.hidden = readWishlist().length === 0;
  };

  const initHeader = () => {
    const header = document.querySelector('[data-shd-header]');
    if (!header || header.dataset.transparent !== 'true') return;
    const sync = () => {
      header.dataset.state = window.scrollY > 80 ? 'solid' : 'transparent';
    };
    sync();
    window.addEventListener('scroll', sync, { passive: true });
  };

  const refreshCartCount = async () => {
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart.js');
      if (!response.ok) return;
      const cart = await response.json();
      document.querySelectorAll('[data-shd-cart-count]').forEach((el) => {
        el.textContent = cart.item_count;
      });
    } catch (error) {
    }
  };

  const CART_SECTION = 'shd-overlays';

  const refreshCartDrawer = async () => {
    const body = document.querySelector('[data-shd-cart-body]');
    const foot = document.querySelector('[data-shd-cart-foot]');
    if (!body) {
      refreshCartCount();
      return;
    }
    body.setAttribute('data-shd-busy', 'true');
    try {
      const response = await fetch(`${window.Shopify.routes.root}?sections=${CART_SECTION}`);
      if (!response.ok) throw new Error('Section nicht erreichbar');
      const data = await response.json();
      const markup = data[CART_SECTION];
      if (!markup) throw new Error('Section leer');

      const doc = new DOMParser().parseFromString(markup, 'text/html');
      const nextBody = doc.querySelector('[data-shd-cart-body]');
      const nextFoot = doc.querySelector('[data-shd-cart-foot]');
      const nextCount = doc.querySelector('[data-shd-cart-count]');

      if (nextBody) body.innerHTML = nextBody.innerHTML;
      if (nextFoot && foot) foot.innerHTML = nextFoot.innerHTML;
      if (nextCount) {
        document.querySelectorAll('[data-shd-cart-count]').forEach((el) => {
          el.textContent = nextCount.textContent.trim();
        });
      }
    } catch (error) {
      refreshCartCount();
    } finally {
      body.removeAttribute('data-shd-busy');
    }
  };

  const changeLine = async (line, quantity) => {
    const body = document.querySelector('[data-shd-cart-body]');
    if (body) body.setAttribute('data-shd-busy', 'true');
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
      });
      if (!response.ok) {
        const error = await response.json().catch(() => ({}));
        throw new Error(error.description || 'Die Menge konnte nicht geändert werden.');
      }
      if (Number(quantity) === 0) toast('Entfernt');
      await refreshCartDrawer();
    } catch (error) {
      toast(error.message);
      if (body) body.removeAttribute('data-shd-busy');
    }
  };

  document.addEventListener('cart:refresh', refreshCartDrawer);

  const initSliders = () => {
    document.querySelectorAll('[data-shd-slider]').forEach((slider) => {
      const slides = Array.from(slider.querySelectorAll('[data-shd-slide]'));
      if (slides.length < 2) return;
      let index = 0;
      const show = (next) => {
        index = (next + slides.length) % slides.length;
        slides.forEach((slide, i) => {
          slide.style.opacity = i === index ? '1' : '0';
        });
      };
      const prev = slider.querySelector('[data-shd-slide-prev]');
      const next = slider.querySelector('[data-shd-slide-next]');
      if (prev) prev.addEventListener('click', () => show(index - 1));
      if (next) next.addEventListener('click', () => show(index + 1));
    });
  };

  const initReveal = () => {
    const targets = document.querySelectorAll('[data-shd-reveal]');
    if (!targets.length) return;

    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const showAll = () => targets.forEach((el) => el.setAttribute('data-revealed', 'true'));

    if (reduced || !('IntersectionObserver' in window)) {
      showAll();
      return;
    }

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.setAttribute('data-revealed', 'true');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px' });

    targets.forEach((el) => observer.observe(el));

    setTimeout(showAll, 2500);
  };

  const initNewsletter = () => {
    document.querySelectorAll('.shd-nl-form').forEach((form) => {
      form.addEventListener('submit', () => {
        const button = form.querySelector('.shd-nl-btn');
        if (!button) return;
        button.dataset.loading = 'true';
        button.textContent = 'Sendet …';
      });
    });
  };

  const FOCUSABLE = 'a[href],button:not([disabled]),input,select,textarea,[tabindex]:not([tabindex="-1"])';
  let openOverlay = null;
  let lastFocused = null;

  const closeOverlay = () => {
    if (!openOverlay) return;
    openOverlay.hidden = true;
    document.documentElement.style.overflow = '';
    document.querySelectorAll('[data-shd-open][aria-expanded]').forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (lastFocused) lastFocused.focus();
    openOverlay = null;
  };

  const showOverlay = (name, trigger) => {
    const overlay = document.querySelector('[data-shd-overlay="' + name + '"]');
    if (!overlay) return;
    closeOverlay();
    lastFocused = trigger || document.activeElement;
    overlay.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    openOverlay = overlay;
    if (trigger && trigger.hasAttribute('aria-expanded')) trigger.setAttribute('aria-expanded', 'true');
    const auto = overlay.querySelector('[data-shd-autofocus]');
    const first = auto || overlay.querySelector(FOCUSABLE);
    if (first) first.focus();
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-shd-open]');
    if (opener) {
      const name = opener.getAttribute('data-shd-open');
      if (name === 'locale') return;
      event.preventDefault();
      showOverlay(name, opener);
      return;
    }
    if (event.target.closest('[data-shd-close]')) {
      event.preventDefault();
      closeOverlay();
      return;
    }
    if (openOverlay && event.target === openOverlay) closeOverlay();
  });

  document.addEventListener('keydown', (event) => {
    if (!openOverlay) return;
    if (event.key === 'Escape') {
      closeOverlay();
      return;
    }
    if (event.key !== 'Tab') return;
    const items = Array.from(openOverlay.querySelectorAll(FOCUSABLE)).filter((el) => el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0];
    const last = items[items.length - 1];
    if (event.shiftKey && document.activeElement === first) {
      event.preventDefault();
      last.focus();
    } else if (!event.shiftKey && document.activeElement === last) {
      event.preventDefault();
      first.focus();
    }
  });

  document.addEventListener('cart:refresh', () => {
    const trigger = document.querySelector('[data-shd-open="cart"]');
    if (trigger) showOverlay('cart', trigger);
  });

  const AGE_KEY = 'shd:age-ok';

  const initAgeGate = () => {
    const gate = document.querySelector('[data-shd-agegate]');
    if (!gate) return;

    let until = 0;
    try {
      until = Number(localStorage.getItem(AGE_KEY) || 0);
    } catch (error) {
      until = 0;
    }
    if (until > Date.now()) return;

    gate.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    const yes = gate.querySelector('[data-shd-age-yes]');
    if (yes) yes.focus();

    gate.querySelector('[data-shd-age-yes]').addEventListener('click', () => {
      const days = Number(gate.getAttribute('data-shd-age-days') || 30);
      try {
        localStorage.setItem(AGE_KEY, String(Date.now() + days * 86400000));
      } catch (error) {
      }
      gate.hidden = true;
      document.documentElement.style.overflow = '';
    });

    const no = gate.querySelector('[data-shd-age-no]');
    if (no) {
      no.addEventListener('click', () => {
        const deny = gate.querySelector('[data-shd-age-deny]');
        if (deny) deny.hidden = false;
      });
    }
  };

  const initNotes = () => {
    document.querySelectorAll('.shd-note__toggle').forEach((toggle) => {
      toggle.addEventListener('click', () => {
        const open = toggle.getAttribute('aria-expanded') === 'true';
        const body = document.getElementById(toggle.getAttribute('aria-controls'));
        const mark = toggle.querySelector('.shd-note__mark');
        toggle.setAttribute('aria-expanded', String(!open));
        if (body) body.hidden = open;
        if (mark) {
          mark.innerHTML = open ? '&plus;' : '&minus;';
          mark.style.background = open ? 'rgba(34,28,24,.1)' : '#B3321E';
          mark.style.color = open ? '#221C18' : '#fff';
        }
      });
    });
  };

  const initProductPage = () => {
    const main = document.getElementById('shd-pdp-image');

    document.querySelectorAll('[data-shd-thumb]').forEach((thumb) => {
      thumb.addEventListener('click', () => {
        if (main) main.src = thumb.getAttribute('data-shd-thumb');
        document.querySelectorAll('[data-shd-thumb]').forEach((other) => {
          other.style.borderColor = other === thumb ? '#B3321E' : 'rgba(34,28,24,.16)';
        });
      });
    });

    const paintQty = (box) => {
      const input = box.querySelector('input[name="quantity"]');
      if (!input) return;
      const value = Math.min(12, Math.max(1, Number(input.value || 1)));
      input.value = value;
      box.querySelectorAll('[data-shd-qty]').forEach((button) => {
        const step = Number(button.getAttribute('data-shd-qty'));
        button.disabled = step < 0 ? value <= 1 : value >= 12;
      });
    };

    document.querySelectorAll('.shd-pdpqty').forEach((box) => {
      box.querySelectorAll('[data-shd-qty]').forEach((button) => {
        button.addEventListener('click', () => {
          if (button.disabled) return;
          const input = box.querySelector('input[name="quantity"]');
          if (!input) return;
          const step = Number(button.getAttribute('data-shd-qty'));
          input.value = Math.min(12, Math.max(1, Number(input.value || 1) + step));
          paintQty(box);
        });
      });

      const input = box.querySelector('input[name="quantity"]');
      if (input) {
        input.addEventListener('change', () => paintQty(box));
        input.addEventListener('blur', () => paintQty(box));
      }

      paintQty(box);
    });

    const paintVariants = () => {
      document.querySelectorAll('.shd-variant').forEach((label) => {
        const input = label.querySelector('input');
        const box = label.querySelector('span');
        if (!input || !box) return;
        if (input.checked) {
          box.style.borderColor = '#B3321E';
          box.style.background = 'rgba(179,50,30,.08)';
        } else {
          box.style.borderColor = 'rgba(34,28,24,.24)';
          box.style.background = 'transparent';
        }
      });
    };
    document.querySelectorAll('.shd-variant input').forEach((input) => {
      input.addEventListener('change', paintVariants);
    });
    paintVariants();
  };

  const initVariantSync = () => {
    const source = document.querySelector('[data-shd-variant-data]');
    const radios = document.querySelectorAll('.shd-variant input[name="id"]');
    if (!source || !radios.length) return;

    let data;
    try {
      data = JSON.parse(source.textContent);
    } catch (err) {
      return;
    }

    const priceEl = document.querySelector('[data-shd-price]');
    const compareEl = document.querySelector('[data-shd-compare]');
    const unitEl = document.querySelector('[data-shd-unit]');
    const unitLineEl = document.querySelector('[data-shd-unit-line]');
    const stockEl = document.querySelector('[data-shd-stock]');
    const submitEl = document.querySelector('[data-shd-submit]');
    const stickyPriceEl = document.querySelector('[data-shd-sticky-price]');
    const stickyAddEl = document.querySelector('[data-shd-sticky-add]');
    const wishEl = document.querySelector('[data-shd-wish][data-shd-wish-price]');

    const apply = (id) => {
      const v = data[id];
      if (!v) return;

      if (priceEl) priceEl.innerHTML = v.price;
      if (compareEl) {
        compareEl.innerHTML = v.compare || '';
        compareEl.style.display = v.compare ? '' : 'none';
      }
      if (unitEl) unitEl.innerHTML = v.unit || '';
      if (unitLineEl) unitLineEl.style.display = v.unit ? '' : 'none';
      if (stockEl) {
        stockEl.textContent = v.available
          ? stockEl.getAttribute('data-shd-stock-in')
          : stockEl.getAttribute('data-shd-stock-out');
        stockEl.style.color = v.available ? '#1E7A4B' : '#B3321E';
      }
      if (submitEl) {
        submitEl.disabled = !v.available;
        submitEl.textContent = v.available ? 'In den Warenkorb' : 'Ausverkauft';
      }
      if (stickyPriceEl) stickyPriceEl.innerHTML = v.price;
      if (stickyAddEl) {
        stickyAddEl.setAttribute('data-shd-add', id);
        stickyAddEl.disabled = !v.available;
      }
      if (wishEl) {
        wishEl.setAttribute('data-shd-wish-price', v.price);
        wishEl.setAttribute('data-shd-wish-variant', v.available ? id : '');
      }
    };

    radios.forEach((input) => {
      input.addEventListener('change', () => {
        if (input.checked) apply(input.value);
      });
    });

    const checked = document.querySelector('.shd-variant input[name="id"]:checked');
    if (checked) apply(checked.value);
  };

  const initPdpForm = () => {
    const form = document.getElementById('shd-pdp-form');
    if (!form) return;
    const submit = form.querySelector('[data-shd-submit]');
    if (!submit) return;

    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (submit.disabled || submit.dataset.loading === 'true') return;

      const original = submit.textContent;
      submit.dataset.loading = 'true';
      submit.textContent = 'Wird hinzugefügt …';

      try {
        const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        });

        if (!response.ok) {
          const error = await response.json().catch(() => ({}));
          throw new Error(error.description || 'Das Produkt konnte nicht hinzugefügt werden.');
        }

        await refreshCartDrawer();
        showOverlay('cart', submit);
      } catch (error) {
        toast(error.message);
      } finally {
        submit.dataset.loading = 'false';
        submit.textContent = original;
      }
    });
  };

  const initLoadMore = () => {
    const wrap = document.querySelector('[data-shd-more-wrap]');
    const grid = document.querySelector('[data-shd-grid]');
    if (!wrap || !grid) return;

    const total = Number(wrap.getAttribute('data-shd-total') || 0);
    const progress = wrap.querySelector('[data-shd-progress]');
    const shownEl = wrap.querySelector('[data-shd-shown]');

    const load = async (event) => {
      const button = event.target.closest('[data-shd-loadmore]');
      if (!button) return;
      event.preventDefault();
      if (button.dataset.loading === 'true') return;

      const url = button.getAttribute('href');
      if (!url) return;

      const original = button.textContent;
      button.dataset.loading = 'true';
      button.setAttribute('aria-busy', 'true');
      button.textContent = 'Wird geladen …';

      try {
        const response = await fetch(url);
        if (!response.ok) throw new Error('Seite nicht erreichbar');
        const doc = new DOMParser().parseFromString(await response.text(), 'text/html');

        const nextGrid = doc.querySelector('[data-shd-grid]');
        if (nextGrid) {
          const fragment = document.createDocumentFragment();
          Array.from(nextGrid.children).forEach((card) => fragment.appendChild(card));
          grid.appendChild(fragment);
        }

        const count = grid.children.length;
        if (shownEl) shownEl.textContent = count;
        if (progress && total > 0) progress.style.width = Math.min(100, Math.round((count / total) * 100)) + '%';

        const nextButton = doc.querySelector('[data-shd-loadmore]');
        if (nextButton && nextButton.getAttribute('href')) {
          button.setAttribute('href', nextButton.getAttribute('href'));
        } else {
          button.remove();
        }
      } catch (error) {
        toast('Es konnten keine weiteren Produkte geladen werden.');
        window.location.href = url;
      } finally {
        if (button.isConnected) {
          button.dataset.loading = 'false';
          button.removeAttribute('aria-busy');
          button.textContent = original;
        }
      }
    };

    wrap.addEventListener('click', load);
  };

  const initStickyAtc = () => {
    const bar = document.querySelector('[data-shd-sticky-atc]');
    const form = document.getElementById('shd-pdp-form');
    if (!bar || !form) return;

    if (!('IntersectionObserver' in window)) return;
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        bar.hidden = entry.isIntersecting;
      });
    }, { rootMargin: '-120px 0px 0px 0px' });
    observer.observe(form);
  };

  const initRecover = () => {
    const login = document.getElementById('shd-login');
    const recover = document.getElementById('shd-recover');
    if (!login || !recover) return;
    const show = (wantRecover) => {
      login.style.display = wantRecover ? 'none' : '';
      recover.style.display = wantRecover ? '' : 'none';
      const focus = (wantRecover ? recover : login).querySelector('input');
      if (focus) focus.focus();
    };
    document.querySelectorAll('[data-shd-recover-show]').forEach((b) => b.addEventListener('click', () => show(true)));
    document.querySelectorAll('[data-shd-recover-hide]').forEach((b) => b.addEventListener('click', () => show(false)));

    if (window.location.hash === '#recover') show(true);
  };

  const initPageHero = () => {
    document.querySelectorAll('[data-shd-pagehero]').forEach((hero) => {
      const slides = [...hero.querySelectorAll('[data-shd-slide]')];
      const dots = [...hero.querySelectorAll('[data-shd-dot]')];
      if (slides.length < 2) return;
      const show = (i) => {
        slides.forEach((s, n) => { s.style.opacity = n === i ? '1' : '0'; });
        dots.forEach((d, n) => {
          d.setAttribute('aria-current', String(n === i));
          const bar = d.firstElementChild;
          if (bar) bar.style.opacity = n === i ? '1' : '.4';
        });
      };
      dots.forEach((d, i) => d.addEventListener('click', () => show(i)));
    });
  };

  const initFacets = () => {
    const form = document.getElementById('shd-facets');
    if (!form) return;
    const body = form.querySelector('#shd-facets-body');
    const toggle = form.querySelector('[data-shd-facets-toggle]');
    if (!body || !toggle) return;

    if (form.querySelector('input[type="checkbox"]:checked')) body.hidden = false;
    toggle.setAttribute('aria-expanded', String(!body.hidden));

    toggle.addEventListener('click', () => {
      body.hidden = !body.hidden;
      toggle.setAttribute('aria-expanded', String(!body.hidden));
    });

    form.querySelectorAll('input[type="checkbox"]').forEach((box) => {
      box.addEventListener('change', () => form.requestSubmit ? form.requestSubmit() : form.submit());
    });
  };


  const initShare = () => {
    const box = document.querySelector('[data-shd-share]');
    if (!box) return;
    const url = box.getAttribute('data-url');
    const title = box.getAttribute('data-title');

    const nativeWrap = box.querySelector('[data-shd-share-native-wrap]');
    const nativeBtn = box.querySelector('[data-shd-share-native]');
    if (nativeWrap && nativeBtn && navigator.share) {
      nativeWrap.hidden = false;
      nativeBtn.addEventListener('click', () => {
        navigator.share({ title, url }).catch(() => {});
      });
    }

    const copyBtn = box.querySelector('[data-shd-share-copy]');
    if (!copyBtn) return;
    copyBtn.addEventListener('click', async () => {
      try {
        await navigator.clipboard.writeText(url);
      } catch (err) {
        const field = document.createElement('input');
        field.value = url;
        document.body.appendChild(field);
        field.select();
        document.execCommand('copy');
        field.remove();
      }
      toast('Link kopiert');
    });
  };

  const boot = () => {
    paintWishlist();
    paintWishDot();
    initHeader();
    initSliders();
    initReveal();
    initNewsletter();
    initAgeGate();
    initNotes();
    initProductPage();
    initPdpForm();
    initVariantSync();
    initStickyAtc();
    initRecover();
    renderWishlist();
    initPageHero();
    initFacets();
    initLoadMore();
    initShare();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
